import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { CircularProgress, IconButton } from '@mui/material';
import PauseIcon from '@mui/icons-material/Pause';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Container from './styles/Container';
import {
  useStartWarehouseMutation,
  useStopWarehouseMutation,
} from '../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import { WAREHOUSE_ICO_COLOR } from '../../constants';

function StartStopWarehouse({ warehouseId, status }) {
  const queryParams = useParams();
  const logisticTaskId = parseInt(queryParams.logisticTaskId, 10);

  const [isStopped, setIsStopped] = useState(status === 'STOPPED');

  const [startWarehouse, { isLoading: isStarting }] = useStartWarehouseMutation();
  const [stopWarehouse, { isLoading: isStopping }] = useStopWarehouseMutation();

  const handleStart = async () => {
    const result = await startWarehouse({ logisticTaskId, warehouseId });
    if (result && !result.error) {
      setIsStopped(false);
    }
  };

  const handleStop = async () => {
    const result = await stopWarehouse({ logisticTaskId, warehouseId });
    if (result && !result.error) {
      setIsStopped(true);
    }
  };

  const playColor = !isStopped ? 'inherit' : WAREHOUSE_ICO_COLOR;
  const stopColor = isStopped ? 'inherit' : WAREHOUSE_ICO_COLOR;

  return (
    <Container>
      <IconButton disabled={!isStopped} title="Возобновить работу" onClick={handleStart}>
        {isStarting ? (
          <CircularProgress size={20} sx={{ color: WAREHOUSE_ICO_COLOR }} />
        ) : (
          <PlayCircleIcon sx={{ color: playColor }} />
        )}
      </IconButton>
      <IconButton disabled={isStopped} title="Остановить работу" onClick={handleStop}>
        {isStopping ? (
          <CircularProgress size={20} sx={{ color: WAREHOUSE_ICO_COLOR }} />
        ) : (
          <PauseIcon sx={{ color: stopColor }} />
        )}
      </IconButton>
    </Container>
  );
}

StartStopWarehouse.propTypes = {
  warehouseId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
};
export default StartStopWarehouse;
